import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateSystemComponent } from 'src/features/systems/api/systemComponents/useCreateSystemComponent';
import { LIST_SYSTEM_COMPONENTS_RESOURCE } from 'src/features/systems/api/systemComponents/useListSystemComponents';
import { SystemComponent } from 'src/features/systems/utils/types';
import { systemsMessages } from 'src/features/systems/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';
import SystemComponentFormModal from 'src/features/systems/components/systemComponents/form/SystemComponentFormModal';
import { SYSTEM_COMPONENT_RESOURCE } from 'src/features/systems/api/systemComponents/useGetSystemComponent';

interface SystemComponentFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedSystemComponent?: SystemComponent;
    children?: React.ReactNode;
}

function CreateSystemComponentFormModal<TData>({ className, semantics }: SystemComponentFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateSystemComponent({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SYSTEM_COMPONENTS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [SYSTEM_COMPONENT_RESOURCE] });

            toast({
                title: formatMessage(systemsMessages.createComponentSuccess),
                description: formatMessage(systemsMessages.createComponentSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <SystemComponentFormModal
            className={className}
            mutate={(data, onSuccess, onError) => mutate({ parkingId, data }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(systemsMessages.addComponentSubtitle)}
        />
    );
}

export default CreateSystemComponentFormModal;
